import React, { useEffect, useState } from "react";
import "./table_search.css";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const Table_search = ({ name, setName, fetch }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (name) {
      setValue(name);
    }else{
      setValue("");
    }
  }, [name]);
  return (
    <>
      <section className="Table_search_sec">
        <div className="search_div">
          <Form.Control
            type="text"
            value={value}
            onChange={(val) => setValue(val?.target?.value)}
            placeholder="Search..."
          />
          <button className="search-btn" onClick={() => setName(value)}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </button>
        </div>
      </section>
    </>
  );
};

export default Table_search;
